import { render, staticRenderFns } from "./NoticeInfo.vue?vue&type=template&id=13887520&scoped=true&"
import script from "./NoticeInfo.vue?vue&type=script&lang=js&"
export * from "./NoticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./NoticeInfo.vue?vue&type=style&index=0&id=13887520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13887520",
  null
  
)

export default component.exports